import makeSlice from '@web/slices/agreement/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {data} = payload

            state.enabled = true
            state.openBankingAgreed = data.agreement?.agreedOpenBank ?? true
            state.familyPayAgreed = true

            state.selected = {
                mallContract: true,
                thirdPeople: true,
                customOrder: true,
                preOrder: true,
                personalDataCrossBorderTransfer: true,
                familyPay: false,
                booking: true,
                shoppingSubscription: true,
            }
        })
    },
})

export default slice.reducer
